import { object, string } from 'yup';
import { PRICE, PROVIDER_ID, SALES, VAT } from './consts';

export const validationSchema = object().shape({
  [PROVIDER_ID]: string().required('select an alleye provider'),
  [PRICE]: string().min(0, 'price is not valid').required('price is required'),
  [VAT]: string().min(0, 'vat is not valid').required('vat is required'),
  [SALES]: string().min(1, 'provide at least 1 license').required('number of licenses is required'),
});
